const React = require("react");

const useResource = (loader, dependencies = []) => {
  const [state, setState] = React.useState({ loading: true, error: "", data: null });
  const requestId = React.useRef(0);
  const reload = React.useCallback(async () => {
    const currentRequest = ++requestId.current;
    setState((old) => ({ ...old, loading: true, error: "" }));
    try { const data = await loader(); if (currentRequest !== requestId.current) return null; setState({ loading: false, error: "", data }); return data; }
    catch (error) { if (currentRequest !== requestId.current) return null; setState({ loading: false, error: error.message || String(error), data: null }); return null; }
  }, dependencies);
  React.useEffect(() => { reload(); return () => { requestId.current += 1; }; }, [reload]);
  return { ...state, reload };
};

module.exports = { useResource };
